import { bananacatImg, ethreumIcon, galaxyGuruImg } from "../images";

export const countries = [
  "Abkhazia",
  "Afghanistan",
  "Albania",
  "Algeria",
  "American Samoa",
  "Andorra",
  "Angola",
  "Anguilla",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Aruba",
  "Ascension",
  "Australia",
  "Australian External Territories",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Barbuda",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "British Indian Ocean Territory",
  "British Virgin Islands",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cape Verde",
  "Cayman Islands",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Christmas Island",
  "Cocos-Keeling Islands",
  "Colombia",
  "Comoros",
  "Congo",
  "Congo, Dem. Rep. of (Zaire)",
  "Cook Islands",
  "Costa Rica",
  "Croatia",
  "Cuba",
  "Curacao",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Diego Garcia",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "East Timor",
  "Easter Island",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Ethiopia",
  "Falkland Islands",
  "Faroe Islands",
  "Fiji",
  "Finland",
  "France",
  "French Antilles",
  "French Guiana",
  "French Polynesia",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Gibraltar",
  "Greece",
  "Greenland",
  "Grenada",
  "Guadeloupe",
  "Guam",
  "Guatemala",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Honduras",
  "Hong Kong SAR China",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy",
  "Ivory Coast",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macau SAR China",
  "Macedonia",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Martinique",
  "Mauritania",
  "Mauritius",
  "Mayotte",
  "Mexico",
  "Micronesia",
  "Midway Island",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Montserrat",
  "Morocco",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "Netherlands Antilles",
  "Nevis",
  "New Caledonia",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Niue",
  "Norfolk Island",
  "North Korea",
  "Northern Mariana Islands",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestinian Territory",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Reunion",
  "Romania",
  "Russia",
  "Rwanda",
  "Samoa",
  "San Marino",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "South Africa",
  "South Georgia and the South Sandwich Islands",
  "South Korea",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Swaziland",
  "Sweden",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Timor Leste",
  "Togo",
  "Tokelau",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Turks and Caicos Islands",
  "Tuvalu",
  "U.S. Virgin Islands",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Venezuela",
  "Vietnam",
  "Wake Island",
  "Wallis and Futuna",
  "Yemen",
  "Zambia",
  "Zanzibar",
  "Zimbabwe",
];
export const allCoins = [
  {
    coinLogo: bananacatImg,
    coinName: "Banana Cat",
    info: "Revolutionizing interstellar trade with seamless crypto transactions",
    creator: {
      img: galaxyGuruImg,
      name: "GalaxyGuru",
    },
    blockChain: {
      img: ethreumIcon,
      name: "Ethereum",
    },
    price: "0.0001 ETH",
    marketCap: "$12.5M",
    buy: "300",
    sell: "100",
    launchDate: "2024-03-15T00:00:00Z",
    socialLinks: {
      telegramLink: "",
      twitterLink: "",
      tiktokLink: "",
    },
    isFeatured: false,
    lastTradeDate: "2025-03-12T00:00:00Z",
    creationDate: "2024-10-25T00:00:00Z",
    lastReplyDate: "2025-11-28T00:00:00Z",
    owner: "User", // New field for ownership filtering
  },
  {
    coinLogo: bananacatImg,
    coinName: "Banana Cat",
    info: "Revolutionizing interstellar trade with seamless crypto transactions",
    creator: {
      img: galaxyGuruImg,
      name: "GalaxyGuru",
    },
    blockChain: {
      img: ethreumIcon,
      name: "Ethereum",
    },
    price: "0.0001 ETH",
    marketCap: "$12.5M",
    buy: "0",
    sell: "100",
    launchDate: "2024-03-20T00:00:00Z",
    socialLinks: {
      telegramLink: "",
      twitterLink: "",
      tiktokLink: "",
    },
    isFeatured: true,
    lastTradeDate: "2025-01-12T00:00:00Z",
    creationDate: "2024-03-15T00:00:00Z",
    lastReplyDate: "2025-01-11T00:00:00Z",
    owner: null,
  },
  {
    coinLogo: bananacatImg,
    coinName: "Banana Cat",
    info: "Revolutionizing interstellar trade with seamless crypto transactions",
    creator: {
      img: galaxyGuruImg,
      name: "GalaxyGuru",
    },
    blockChain: {
      img: ethreumIcon,
      name: "Ethereum",
    },
    price: "0.0001 ETH",
    marketCap: "$12.5M",
    buy: "300",
    sell: "100",
    launchDate: "2024-03-15T00:00:00Z",
    socialLinks: {
      telegramLink: "",
      twitterLink: "",
      tiktokLink: "",
    },
    isFeatured: true,
    lastTradeDate: "2024-03-12T00:00:00Z",
    creationDate: "2022-10-25T00:00:00Z",
    lastReplyDate: "2021-11-28T00:00:00Z",
    owner: "User",
  },
  {
    coinLogo: bananacatImg,
    coinName: "Banana Cat",
    info: "Revolutionizing interstellar trade with seamless crypto transactions",
    creator: {
      img: galaxyGuruImg,
      name: "GalaxyGuru",
    },
    blockChain: {
      img: ethreumIcon,
      name: "Ethereum",
    },
    price: "0.0001 ETH",
    marketCap: "$12.5M",
    buy: "300",
    sell: "100",
    launchDate: "2024-03-15T00:00:00Z",
    socialLinks: {
      telegramLink: "",
      twitterLink: "",
      tiktokLink: "",
    },
    isFeatured: false,
    lastTradeDate: "2025-03-12T00:00:00Z",
    creationDate: "2024-10-25T00:00:00Z",
    lastReplyDate: "2025-11-28T00:00:00Z",
    owner: "User", // New field for ownership filtering
  },
  {
    coinLogo: bananacatImg,
    coinName: "Banana Cat",
    info: "Revolutionizing interstellar trade with seamless crypto transactions",
    creator: {
      img: galaxyGuruImg,
      name: "GalaxyGuru",
    },
    blockChain: {
      img: ethreumIcon,
      name: "Ethereum",
    },
    price: "0.0001 ETH",
    marketCap: "$12.5M",
    buy: "0",
    sell: "100",
    launchDate: "2024-03-20T00:00:00Z",
    socialLinks: {
      telegramLink: "",
      twitterLink: "",
      tiktokLink: "",
    },
    isFeatured: true,
    lastTradeDate: "2025-01-12T00:00:00Z",
    creationDate: "2024-03-15T00:00:00Z",
    lastReplyDate: "2025-01-11T00:00:00Z",
    owner: null,
  },
  {
    coinLogo: bananacatImg,
    coinName: "Banana Cat",
    info: "Revolutionizing interstellar trade with seamless crypto transactions",
    creator: {
      img: galaxyGuruImg,
      name: "GalaxyGuru",
    },
    blockChain: {
      img: ethreumIcon,
      name: "Ethereum",
    },
    price: "0.0001 ETH",
    marketCap: "$12.5M",
    buy: "300",
    sell: "100",
    launchDate: "2024-03-15T00:00:00Z",
    socialLinks: {
      telegramLink: "",
      twitterLink: "",
      tiktokLink: "",
    },
    isFeatured: true,
    lastTradeDate: "2024-03-12T00:00:00Z",
    creationDate: "2022-10-25T00:00:00Z",
    lastReplyDate: "2021-11-28T00:00:00Z",
    owner: "User",
  },
  {
    coinLogo: bananacatImg,
    coinName: "Banana Cat",
    info: "Revolutionizing interstellar trade with seamless crypto transactions",
    creator: {
      img: galaxyGuruImg,
      name: "GalaxyGuru",
    },
    blockChain: {
      img: ethreumIcon,
      name: "Ethereum",
    },
    price: "0.0001 ETH",
    marketCap: "$12.5M",
    buy: "300",
    sell: "100",
    launchDate: "2024-03-15T00:00:00Z",
    socialLinks: {
      telegramLink: "",
      twitterLink: "",
      tiktokLink: "",
    },
    isFeatured: false,
    lastTradeDate: "2025-03-12T00:00:00Z",
    creationDate: "2024-10-25T00:00:00Z",
    lastReplyDate: "2025-11-28T00:00:00Z",
    owner: "User", // New field for ownership filtering
  },
  {
    coinLogo: bananacatImg,
    coinName: "Banana Cat",
    info: "Revolutionizing interstellar trade with seamless crypto transactions",
    creator: {
      img: galaxyGuruImg,
      name: "GalaxyGuru",
    },
    blockChain: {
      img: ethreumIcon,
      name: "Ethereum",
    },
    price: "0.0001 ETH",
    marketCap: "$12.5M",
    buy: "0",
    sell: "100",
    launchDate: "2024-03-20T00:00:00Z",
    socialLinks: {
      telegramLink: "",
      twitterLink: "",
      tiktokLink: "",
    },
    isFeatured: true,
    lastTradeDate: "2025-01-12T00:00:00Z",
    creationDate: "2024-03-15T00:00:00Z",
    lastReplyDate: "2025-01-11T00:00:00Z",
    owner: null,
  },
  {
    coinLogo: bananacatImg,
    coinName: "Banana Cat",
    info: "Revolutionizing interstellar trade with seamless crypto transactions",
    creator: {
      img: galaxyGuruImg,
      name: "GalaxyGuru",
    },
    blockChain: {
      img: ethreumIcon,
      name: "Ethereum",
    },
    price: "0.0001 ETH",
    marketCap: "$12.5M",
    buy: "300",
    sell: "100",
    launchDate: "2024-03-15T00:00:00Z",
    socialLinks: {
      telegramLink: "",
      twitterLink: "",
      tiktokLink: "",
    },
    isFeatured: true,
    lastTradeDate: "2024-03-12T00:00:00Z",
    creationDate: "2022-10-25T00:00:00Z",
    lastReplyDate: "2021-11-28T00:00:00Z",
    owner: "User",
  },
  {
    coinLogo: bananacatImg,
    coinName: "Banana Cat",
    info: "Revolutionizing interstellar trade with seamless crypto transactions",
    creator: {
      img: galaxyGuruImg,
      name: "GalaxyGuru",
    },
    blockChain: {
      img: ethreumIcon,
      name: "Ethereum",
    },
    price: "0.0001 ETH",
    marketCap: "$12.5M",
    buy: "300",
    sell: "100",
    launchDate: "2024-03-15T00:00:00Z",
    socialLinks: {
      telegramLink: "",
      twitterLink: "",
      tiktokLink: "",
    },
    isFeatured: false,
    lastTradeDate: "2025-03-12T00:00:00Z",
    creationDate: "2024-10-25T00:00:00Z",
    lastReplyDate: "2025-11-28T00:00:00Z",
    owner: "User", // New field for ownership filtering
  },
  {
    coinLogo: bananacatImg,
    coinName: "Banana Cat",
    info: "Revolutionizing interstellar trade with seamless crypto transactions",
    creator: {
      img: galaxyGuruImg,
      name: "GalaxyGuru",
    },
    blockChain: {
      img: ethreumIcon,
      name: "Ethereum",
    },
    price: "0.0001 ETH",
    marketCap: "$12.5M",
    buy: "0",
    sell: "100",
    launchDate: "2024-03-20T00:00:00Z",
    socialLinks: {
      telegramLink: "",
      twitterLink: "",
      tiktokLink: "",
    },
    isFeatured: true,
    lastTradeDate: "2025-01-12T00:00:00Z",
    creationDate: "2024-03-15T00:00:00Z",
    lastReplyDate: "2025-01-11T00:00:00Z",
    owner: null,
  },
  {
    coinLogo: bananacatImg,
    coinName: "Banana Cat",
    info: "Revolutionizing interstellar trade with seamless crypto transactions",
    creator: {
      img: galaxyGuruImg,
      name: "GalaxyGuru",
    },
    blockChain: {
      img: ethreumIcon,
      name: "Ethereum",
    },
    price: "0.0001 ETH",
    marketCap: "$12.5M",
    buy: "300",
    sell: "100",
    launchDate: "2024-03-15T00:00:00Z",
    socialLinks: {
      telegramLink: "",
      twitterLink: "",
      tiktokLink: "",
    },
    isFeatured: true,
    lastTradeDate: "2024-03-12T00:00:00Z",
    creationDate: "2022-10-25T00:00:00Z",
    lastReplyDate: "2021-11-28T00:00:00Z",
    owner: "User",
  },
  {
    coinLogo: bananacatImg,
    coinName: "Banana Cat",
    info: "Revolutionizing interstellar trade with seamless crypto transactions",
    creator: {
      img: galaxyGuruImg,
      name: "GalaxyGuru",
    },
    blockChain: {
      img: ethreumIcon,
      name: "Ethereum",
    },
    price: "0.0001 ETH",
    marketCap: "$12.5M",
    buy: "300",
    sell: "100",
    launchDate: "2024-03-15T00:00:00Z",
    socialLinks: {
      telegramLink: "",
      twitterLink: "",
      tiktokLink: "",
    },
    isFeatured: false,
    lastTradeDate: "2025-03-12T00:00:00Z",
    creationDate: "2024-10-25T00:00:00Z",
    lastReplyDate: "2025-11-28T00:00:00Z",
    owner: "User", // New field for ownership filtering
  },
  {
    coinLogo: bananacatImg,
    coinName: "Banana Cat",
    info: "Revolutionizing interstellar trade with seamless crypto transactions",
    creator: {
      img: galaxyGuruImg,
      name: "GalaxyGuru",
    },
    blockChain: {
      img: ethreumIcon,
      name: "Ethereum",
    },
    price: "0.0001 ETH",
    marketCap: "$12.5M",
    buy: "0",
    sell: "100",
    launchDate: "2024-03-20T00:00:00Z",
    socialLinks: {
      telegramLink: "",
      twitterLink: "",
      tiktokLink: "",
    },
    isFeatured: true,
    lastTradeDate: "2025-01-12T00:00:00Z",
    creationDate: "2024-03-15T00:00:00Z",
    lastReplyDate: "2025-01-11T00:00:00Z",
    owner: null,
  },
  {
    coinLogo: bananacatImg,
    coinName: "Banana Cat",
    info: "Revolutionizing interstellar trade with seamless crypto transactions",
    creator: {
      img: galaxyGuruImg,
      name: "GalaxyGuru",
    },
    blockChain: {
      img: ethreumIcon,
      name: "Ethereum",
    },
    price: "0.0001 ETH",
    marketCap: "$12.5M",
    buy: "300",
    sell: "100",
    launchDate: "2024-03-15T00:00:00Z",
    socialLinks: {
      telegramLink: "",
      twitterLink: "",
      tiktokLink: "",
    },
    isFeatured: true,
    lastTradeDate: "2024-03-12T00:00:00Z",
    creationDate: "2022-10-25T00:00:00Z",
    lastReplyDate: "2021-11-28T00:00:00Z",
    owner: "User",
  },
];
export const dummyComments = [
  {
    id: 1,
    content: {
      text: "This is the first dummy thread. Feel free to react!",
      image: null,
    },
    upvotes: 10,
    downvotes: 2,
    timestamp: new Date(Date.now() - 3600000).toISOString(), // 1 hour ago
    reaction: null,
    user: {
      name: "Current User",
      avatar: galaxyGuruImg,
    },
  },
  {
    id: 2,
    content: {
      text: "Another example thread for testing reactions.",
      image: null,
    },
    upvotes: 5,
    downvotes: 1,
    timestamp: new Date(Date.now() - 7200000).toISOString(), // 2 hours ago
    reaction: null,
    user: {
      name: "Current User",
      avatar: galaxyGuruImg,
    },
  },
  {
    id: 3,
    content: {
      text: "Another example thread for testing reactions.",
      image: null,
    },
    upvotes: 5,
    downvotes: 1,
    timestamp: new Date(Date.now() - 7200000).toISOString(), // 2 hours ago
    reaction: null,
    user: {
      name: "Current User",
      avatar: galaxyGuruImg,
    },
  },
  {
    id: 4,
    content: {
      text: "Another example thread for testing reactions.",
      image: null,
    },
    upvotes: 5,
    downvotes: 1,
    timestamp: new Date(Date.now() - 7200000).toISOString(), // 2 hours ago
    reaction: null,
    user: {
      name: "Current User",
      avatar: galaxyGuruImg,
    },
  },
  {
    id: 5,
    content: {
      text: "Another example thread for testing reactions.",
      image: null,
    },
    upvotes: 5,
    downvotes: 1,
    timestamp: new Date(Date.now() - 7200000).toISOString(), // 2 hours ago
    reaction: null,
    user: {
      name: "Current User",
      avatar: galaxyGuruImg,
    },
  },
  {
    id: 6,
    content: {
      text: "Another example thread for testing reactions.",
      image: null,
    },
    upvotes: 5,
    downvotes: 1,
    timestamp: new Date(Date.now() - 7200000).toISOString(), // 2 hours ago
    reaction: null,
    user: {
      name: "Current User",
      avatar: galaxyGuruImg,
    },
  },
  {
    id: 7,
    content: {
      text: "Another example thread for testing reactions.",
      image: null,
    },
    upvotes: 5,
    downvotes: 1,
    timestamp: new Date(Date.now() - 7200000).toISOString(), // 2 hours ago
    reaction: null,
    user: {
      name: "Current User",
      avatar: galaxyGuruImg,
    },
  },
  {
    id: 8,
    content: {
      text: "Another example thread for testing reactions.",
      image: null,
    },
    upvotes: 5,
    downvotes: 1,
    timestamp: new Date(Date.now() - 7200000).toISOString(), // 2 hours ago
    reaction: null,
    user: {
      name: "Current User",
      avatar: galaxyGuruImg,
    },
  },
  {
    id: 9,
    content: {
      text: "Another example thread for testing reactions.",
      image: null,
    },
    upvotes: 5,
    downvotes: 1,
    timestamp: new Date(Date.now() - 7200000).toISOString(), // 2 hours ago
    reaction: null,
    user: {
      name: "Current User",
      avatar: galaxyGuruImg,
    },
  },
  {
    id: 10,
    content: {
      text: "Another example thread for testing reactions.",
      image: null,
    },
    upvotes: 5,
    downvotes: 1,
    timestamp: new Date(Date.now() - 7200000).toISOString(), // 2 hours ago
    reaction: null,
    user: {
      name: "Current User",
      avatar: galaxyGuruImg,
    },
  },
  {
    id: 11,
    content: {
      text: "Another example thread for testing reactions.",
      image: null,
    },
    upvotes: 5,
    downvotes: 1,
    timestamp: new Date(Date.now() - 7200000).toISOString(), // 2 hours ago
    reaction: null,
    user: {
      name: "Current User",
      avatar: galaxyGuruImg,
    },
  },
  {
    id: 12,
    content: {
      text: "Another example thread for testing reactions.",
      image: null,
    },
    upvotes: 5,
    downvotes: 1,
    timestamp: new Date(Date.now() - 7200000).toISOString(), // 2 hours ago
    reaction: null,
    user: {
      name: "Current User",
      avatar: galaxyGuruImg,
    },
  },
  {
    id: 13,
    content: {
      text: "Another example thread for testing reactions.",
      image: null,
    },
    upvotes: 5,
    downvotes: 1,
    timestamp: new Date(Date.now() - 7200000).toISOString(), // 2 hours ago
    reaction: null,
    user: {
      name: "Current User",
      avatar: galaxyGuruImg,
    },
  },
  {
    id: 14,
    content: {
      text: "Another example thread for testing reactions.",
      image: null,
    },
    upvotes: 5,
    downvotes: 1,
    timestamp: new Date(Date.now() - 7200000).toISOString(), // 2 hours ago
    reaction: null,
    user: {
      name: "Current User",
      avatar: galaxyGuruImg,
    },
  },
  {
    id: 15,
    content: {
      text: "Another example thread for testing reactions.",
      image: null,
    },
    upvotes: 5,
    downvotes: 1,
    timestamp: new Date(Date.now() - 7200000).toISOString(), // 2 hours ago
    reaction: null,
    user: {
      name: "Current User",
      avatar: galaxyGuruImg,
    },
  },
  // Add more threads as needed with incrementing `id`...
];
